var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _circle2, _rect, _rect2, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeadlinestopwatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 50 50",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}.cls-2{fill:#ffba50;}.cls-3{fill:#ffffff;}.cls-4{fill:#7cc05b;}.cls-5{fill:#ff8e5a;}.cls-6{fill:#d12200;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43,8.277H40.548V7a2.5,2.5,0,0,0-2.5-2.5H37A2.5,2.5,0,0,0,34.5,7V8.277H15.5V7A2.5,2.5,0,0,0,13,4.5H11.952A2.5,2.5,0,0,0,9.452,7V8.277H7a2.5,2.5,0,0,0-2.5,2.5V43A2.5,2.5,0,0,0,7,45.5H43A2.5,2.5,0,0,0,45.5,43V10.777A2.5,2.5,0,0,0,43,8.277Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.028,15.557a14.472,14.472,0,1,1-14.47,14.471A14.488,14.488,0,0,1,30.028,15.557Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.005,41.831a11.8,11.8,0,1,0-11.8-11.8A11.817,11.817,0,0,0,30.005,41.831Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.005,19.226a10.8,10.8,0,1,1-10.8,10.8A10.815,10.815,0,0,1,30.005,19.226Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M7,44.5A1.5,1.5,0,0,1,5.5,43V15.468H24.848A15.446,15.446,0,0,0,24.606,44.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.5,43A1.5,1.5,0,0,1,43,44.5H35.451A15.525,15.525,0,0,0,44.5,35.451Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.318,19.841a2.411,2.411,0,1,0,2.411,2.41A2.413,2.413,0,0,0,10.318,19.841Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M10.318,23.663a1.411,1.411,0,1,1,1.411-1.412A1.413,1.413,0,0,1,10.318,23.663Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.318,27.618a2.411,2.411,0,1,0,2.411,2.41A2.413,2.413,0,0,0,10.318,27.618Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M10.318,31.439a1.411,1.411,0,1,1,1.411-1.411A1.412,1.412,0,0,1,10.318,31.439Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10.318,
    cy: 37.806,
    r: 2.411
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 10.318,
    cy: 37.806,
    r: 1.411
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 6.446,
    rx: 1.5,
    width: 4.045,
    x: 35.503,
    y: 5.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    height: 6.446,
    rx: 1.5,
    width: 4.045,
    x: 10.452,
    y: 5.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M5.5,10.777A1.5,1.5,0,0,1,7,9.277H9.452v1.169a2.5,2.5,0,0,0,2.5,2.5H13a2.5,2.5,0,0,0,2.5-2.5V9.277H34.5v1.169a2.5,2.5,0,0,0,2.5,2.5h1.045a2.5,2.5,0,0,0,2.5-2.5V9.277H43a1.5,1.5,0,0,1,1.5,1.5v3.691H5.5Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.209,15.468H44.5v9.138A15.525,15.525,0,0,0,35.209,15.468Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.028,36.683a.5.5,0,0,0-.5.5v1.626a.5.5,0,0,0,1,0V37.183A.5.5,0,0,0,30.028,36.683Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.32,30.528h1.626a.5.5,0,1,0,0-1H21.32a.5.5,0,0,0,0,1Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34,35.984a.5.5,0,0,0-.865.5l.812,1.409a.5.5,0,0,0,.865-.5Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.055,24.217a.5.5,0,0,0,.432.25.5.5,0,0,0,.25-.067.5.5,0,0,0,.183-.683l-.813-1.408a.5.5,0,1,0-.865.5Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.609,33.146,22.2,33.96a.5.5,0,1,0,.5.865l1.408-.813a.5.5,0,1,0-.5-.866Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.126,27a.494.494,0,0,0,.25-.067l1.409-.813a.5.5,0,1,0-.5-.866l-1.409.813a.5.5,0,0,0,.25.933Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.815,34l-1.408-.813a.5.5,0,0,0-.5.866l1.408.812a.5.5,0,1,0,.5-.865Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.232,26.161l1.409.813a.5.5,0,0,0,.5-.866L22.732,25.3a.5.5,0,0,0-.5.866Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.357,38.021a.5.5,0,0,0,.683-.182l.814-1.408a.5.5,0,0,0-.866-.5l-.813,1.408A.5.5,0,0,0,25.357,38.021Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.253,24.346a.5.5,0,0,0,.683-.183l.813-1.408a.5.5,0,1,0-.865-.5l-.814,1.408A.5.5,0,0,0,33.253,24.346Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.028,32.277a2.25,2.25,0,0,0,2.189-1.749h6.1a.5.5,0,0,0,0-1h-6.1a2.255,2.255,0,0,0-1.712-1.7V21.439a.5.5,0,0,0-1,0v6.409a2.245,2.245,0,0,0,.523,4.429Zm0-3.5a1.249,1.249,0,1,1-1.248,1.248A1.25,1.25,0,0,1,30.028,28.78Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeadlinestopwatch);
export default __webpack_public_path__ + "static/media/deadlinestopwatch.a5bd8b2a5ce917f451982237c8674c96.svg";
export { ForwardRef as ReactComponent };